import type { CSSProperties, ReactNode } from 'react';
import type { CmDeliverable } from '@feature/contract-mgmt/types/contract-mgmt-components';
import type { ModalActor, ProcRow } from '@type/store';

/** Loose keyed form state shared across modal editors. */
export type ModalFormState = Record<string, unknown>;

export type C3FormRow = Record<string, unknown>;

export interface ModalFieldProps {
  label: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export interface ModalFormFooterProps {
  onClose: () => void;
  onSave?: () => void;
  audit?: string;
}

export function formStr(form: ModalFormState, key: string): string {
  const v = form[key];
  return v == null ? '' : String(v);
}

export function formNum(form: ModalFormState, key: string): number {
  return Number(form[key]) || 0;
}

export function formField(form: ModalFormState, key: string): string {
  return formStr(form, key);
}

export function parseOptionalCount(val: unknown): number | null {
  if (val === null || val === undefined || val === '') return null;
  const n = Number(val);
  return Number.isNaN(n) ? null : n;
}

export function buildGenderCounts(
  form: ModalFormState,
  maleKey: string,
  femaleKey: string,
): Record<string, number | null> {
  const male = parseOptionalCount(form[maleKey]);
  const female = parseOptionalCount(form[femaleKey]);
  if (male == null && female == null) {
    return { [maleKey]: null, [femaleKey]: null };
  }
  return {
    [maleKey]: male ?? 0,
    [femaleKey]: female ?? 0,
  };
}

export function asProcRow(row: Record<string, unknown> | undefined): ProcRow {
  return (row ?? {}) as ProcRow;
}

export function modalActorAsUser(actor: ModalActor | null | undefined): ModalActor | null {
  return actor ?? null;
}

export function formMonths(form: ModalFormState): Record<string, unknown> {
  const months = form.months;
  if (months && typeof months === 'object' && !Array.isArray(months)) {
    return months as Record<string, unknown>;
  }
  return {};
}

export function formDeliverables(form: ModalFormState): CmDeliverable[] {
  const list = form.deliverables;
  return Array.isArray(list) ? (list as CmDeliverable[]) : [];
}
